// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL;
export const BASE_DATA_COTTAGE_BACKEND_URL = process.env.REACT_APP_DATASERVICE_BACKEND_URL;
